module.exports = __webpack_public_path__ + "static/img/dd-customer-04.15fca2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-customer-04.jpg
// module id = rT8E
// module chunks = 1